import { DOCK_CATEGORIES_TYPES } from '../../../../types/dockTypes'
import { useLicensedWidgets } from '../../../../hooks/useLicensedWidgets'
import { LicensedWidgetsSection } from '../licensed-widgets-section'
import { SECTION_TITLES } from '../../utils/widgetsByCategory'

export const FeedTableContainer = () => {
	const widgets = useLicensedWidgets(DOCK_CATEGORIES_TYPES.FOOD_TABLE)
	return (
		<LicensedWidgetsSection
			widgets={widgets}
			title={SECTION_TITLES[DOCK_CATEGORIES_TYPES.FOOD_TABLE]}
		/>
	)
}
